import { IAudioItem } from 'types/audio'
import { AUDIO_ITEM_COLORS } from './consts'
import { getIsLibrarySound } from 'store/features/projectData/utils'
import { PROJECT_AUDIO_TYPES } from 'consts/audio'
import { getLimitsPerDevice } from 'services/waveform-manager/helpers'

export const getAudioItemBackgroundColor = (
  dataType: string,
  isDraft: boolean = false
): string => {
  const audioItem = AUDIO_ITEM_COLORS[dataType]
  return (
    (isDraft && audioItem.draftBackgroundColor) || audioItem.backgroundColor
  )
}

export const getIsAudioDecodeAllowed = (
  data: IAudioItem,
  fileSize?: number
) => {
  const { sizeLimit } = getLimitsPerDevice()
  // temporal solution to diff lib/user sounds, all the lib sounds have "_second " part,
  // we do not have any type or data diff between user and lib sounds,
  // and in bk part, we do not pass the lib sound filesize to fe,(restricted info)
  const isLibSound =
    data.type !== PROJECT_AUDIO_TYPES.SOUND || getIsLibrarySound(data.mediaPath)

  const isAllowedToDecodeWaves =
    isLibSound || (fileSize !== undefined && fileSize < sizeLimit)

  return isAllowedToDecodeWaves
}
